import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { ComponentType } from '@angular/cdk/overlay';

import { BrnOverlayService } from '../../core/services/brn-overlay.service';

@Directive({
  selector: '[brnPopup]',
})
export class PopupDirective {
  @Input()
  component!: ComponentType<any>;
  @Input()
  data?: any;
  @Input()
  position?: 'right' | 'bottom' | 'left' | 'top' | 'right-center';
  @Input()
  appendClass?: string;
  @Input()
  offsetX?: number;
  @Input()
  offsetY?: number;

  // event for watching popup open/close status
  @Output()
  popupStatus = new EventEmitter<boolean>();

  constructor(
    private element: ElementRef,
    private overlayService: BrnOverlayService
  ) {}

  @HostListener('click')
  onClick(): void {
    this.popupStatus.emit(true);
    this.createOverlay();
  }

  private createOverlay(): void {
    const overlayRef = this.overlayService.createOverlayPopup(
      this.component,
      this.element,
      {
        data: this.data,
        position: this.position,
        class: this.appendClass,
        offsetX: this.offsetX,
        offsetY: this.offsetY,
      }
    );
    overlayRef.detachments().subscribe(() => {
      this.popupStatus.emit(false);
    });
  }
}
